import React from "react";
export const ChevronIcon = ({ className, style, fill }) => {
    return (React.createElement("svg", { className: className, style: { ...style }, fill: 'none', height: '24', viewBox: '0 0 24 24', width: '24', xmlns: 'http://www.w3.org/2000/svg' },
        React.createElement("path", { fill: fill || "var(--black)", fillRule: 'evenodd', d: 'M9.293 17.707a1 1 0 0 1 0-1.414L13.586 12 9.293 7.707a1 1 0 0 1 1.414-1.414l5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414 0Z', clipRule: 'evenodd' })));
};
